module.exports = __webpack_public_path__ + "img/partner-ujungkulon.cfff06e3.png";